import { Injectable, signal } from '@angular/core';

export type MessageType = 'success' | 'error' | 'info';

export interface AppMessage {
	readonly id: string;
	readonly type: MessageType;
	readonly title: string;
	readonly detail?: string;
}

@Injectable({ providedIn: 'root' })
export class MessagesService {
	private readonly messagesState = signal<readonly AppMessage[]>([]);
	readonly messages = this.messagesState.asReadonly();

	success(title: string, detail?: string): string {
		return this.show('success', title, detail);
	}

	error(title: string, detail?: string): string {
		return this.show('error', title, detail, 7000);
	}

	info(title: string, detail?: string): string {
		return this.show('info', title, detail);
	}

	dismiss(id: string): void {
		this.messagesState.update((messages) =>
			messages.filter((message) => message.id !== id),
		);
	}

	clear(): void {
		this.messagesState.set([]);
	}

	private show(
		type: MessageType,
		title: string,
		detail?: string,
		duration = 4500,
	): string {
		const id = crypto.randomUUID();
		this.messagesState.update((messages) => [
			...messages.slice(-3),
			{ id, type, title, detail },
		]);
		setTimeout(() => this.dismiss(id), duration);
		return id;
	}
}
